import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed, useContext } from '@nuxtjs/composition-api';
import { GETTERS as UNREAD_NOTIFICATIONS_GETTERS } from '~/store/affility/user/notifications/unread/names';
import { ACTIONS as SIDEBAR_ACTIONS } from '~/store/affility/user/notifications/sidebar/names';

interface Props {
    theme?: 'light' | 'dark',
    disabled?: boolean,
    type?: 'outline' | 'tonal' | 'icon',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationToggle',
  props: {
    theme: null,
    disabled: { type: Boolean },
    type: { default: 'tonal' }
  },
  setup(__props: any) {

const props = __props as { theme?: 'light' | 'dark', disabled?: boolean, type: 'outline' | 'tonal' | 'icon' };



const {
    theme,
    disabled,
    type,
} = toRefs(props);

const { store } = useContext();

const unreadNotifications = computed(() => store.getters[`affility/user/notifications/unread/${UNREAD_NOTIFICATIONS_GETTERS.UNREAD_NOTIFICATIONS}`]);

const openNotificationsSidebar = store.dispatch.bind(null, `affility/user/notifications/sidebar/${SIDEBAR_ACTIONS.OPEN_NOTIFICATIONS_LOAD_OR_UPDATE_FIRST_HISTORY_PAGE_IF_NEEDED}`);


return { __sfc: true,props, theme, disabled, type, store, unreadNotifications, openNotificationsSidebar }
}

})